export enum HubMethods {
    RetrieveCaMeetingRequestContext = 'RetrieveCaMeetingRequestContext',
    OnCaMeetingRequestContext = 'OnCaMeetingRequestContext',
    CreateCaResultForPrep = 'CreateCaResultForPrep',
    OnCaResultForPrep = 'OnCaResultForPrep',
    RetrieveCaResult = 'RetrieveCaResult',
    OnCaResult = 'OnCaResult',
}
